export function getMixinContext() {
  var _win$webkit, _win$webkit$messageHa, _win$MixinContext;

  var ctx = {};
  var win = window;

  if ((_win$webkit = win.webkit) !== null && _win$webkit !== void 0 && (_win$webkit$messageHa = _win$webkit.messageHandlers) !== null && _win$webkit$messageHa !== void 0 && _win$webkit$messageHa.MixinContext) {
    ctx = JSON.parse(prompt("MixinContext.getContext()"));
    ctx.platform = ctx.platform || "iOS";
  } else if (typeof ((_win$MixinContext = win.MixinContext) === null || _win$MixinContext === void 0 ? void 0 : _win$MixinContext.getContext) === "function") {
    ctx = JSON.parse(win.MixinContext.getContext());
    ctx.platform = ctx.platform || "Android";
  }

  return ctx;
}
export function isMixin() {
  var platform = getMixinContext().platform;
  return platform === "iOS" || platform === "Android";
}
export function setMixinTheme(color) {
  var _document$querySelect;

  document.querySelectorAll("[name='theme-color']").forEach(function (node) {
    return node.remove();
  });
  var meta = document.createElement("meta");
  meta.name = "theme-color";
  meta.content = color;
  (_document$querySelect = document.querySelector("head")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.appendChild(meta);
  setTimeout(function () {
    loadMixinTheme();
  }, 50);
}
export function loadMixinTheme() {
  var platform = getMixinContext().platform;
  var win = window;

  switch (platform) {
    case "iOS":
      win.webkit.messageHandlers.reloadTheme.postMessage("");
      return;

    case "Android":
      win.MixinContext.reloadTheme();
  }
}
export function isDarkTheme() {
  var _window$matchMedia$ma, _window$matchMedia, _window;

  try {
    var context = getMixinContext();

    if (context !== null && context !== void 0 && context.appearance) {
      return context.appearance === "dark";
    }
  } catch (error) {
    console.log(error);
  }

  return (_window$matchMedia$ma = (_window$matchMedia = (_window = window).matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(_window, "(prefers-color-scheme: dark)").matches) !== null && _window$matchMedia$ma !== void 0 ? _window$matchMedia$ma : false;
}
export function genPaymentUrl(data) {
  var amount = data.amount,
      assetId = data.assetId,
      memo = data.memo,
      recipient = data.recipient,
      traceId = data.traceId;
  return "mixin://pay?recipient=".concat(recipient, "&asset=").concat(assetId, "&amount=").concat(amount, "&trace=").concat(traceId, "&memo=").concat(memo);
}